__turbopack_context__.v({
  "error": "Alert-module-scss-module__r7558G__error",
  "important": "Alert-module-scss-module__r7558G__important",
  "info": "Alert-module-scss-module__r7558G__info",
  "success": "Alert-module-scss-module__r7558G__success",
  "text": "Alert-module-scss-module__r7558G__text",
  "warning": "Alert-module-scss-module__r7558G__warning",
});
